import { deleteInvoiceItem } from "../../api/invoiceService";

export const useDeleteInvoiceItem = (successCallback) => {
    const remove = async (id) => {
        try {
            await deleteInvoiceItem(id);
            successCallback();
        } catch (error) {
            console.error("Failed to delete invoice item:", error);
            throw error;
        }
    };

    return { remove };
};